import { SelectValue } from '../../../Components/Base/Select/Select';

export default function getTermItemId(
	value?: SelectValue | string,
): string | undefined {
	if (typeof value === 'string') {
		return value || undefined;
	}

	return typeof value?.value === 'string' ? value.value : undefined;
}
